import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "panel"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 gy-2" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, " Summary ", -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "card-text" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Name: ")
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = {
  class: "btn-toolbar justify-content-between mt-0 m-2",
  role: "toolbar",
  "aria-label": "Actions"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("button", {
  class: "ms-auto btn btn-outline-danger",
  "data-bs-toggle": "modal",
  "data-bs-target": "#deleteModal"
}, "Delete export", -1)
const _hoisted_18 = { class: "col-md-6 gy-2" }
const _hoisted_19 = { class: "card" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, "Files", -1)
const _hoisted_21 = { class: "card-body p-0" }
const _hoisted_22 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_23 = { class: "table table-striped mb-0" }
const _hoisted_24 = { scope: "col" }
const _hoisted_25 = {
  class: "modal fade",
  id: "deleteModal",
  tabindex: "-1",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true"
}
const _hoisted_26 = { class: "modal-dialog" }
const _hoisted_27 = { class: "modal-content" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "deleteModalLabel"
  }, "Delete this export"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "modal-body" }, " Thos export and related data will be deleted permanently ", -1)
const _hoisted_30 = { class: "modal-footer" }
const _hoisted_31 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, "Cancel", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_block = _resolveComponent("error-block")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("h1", null, _toDisplayString(_ctx.msg), 1),
      _createVNode(_component_error_block, { errors: _ctx.errors }, null, 8, ["errors"]),
      (_ctx.receiverexport)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode("div", _hoisted_7, [
                    _createVNode("p", _hoisted_8, [
                      _hoisted_9,
                      _createVNode(_component_router_link, {
                        to: '/sheqsy/company/' + _ctx.receiverexport.SheqsyCompanyUId
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.receiverexport.Name), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _hoisted_10,
                      _createTextVNode(" Type: " + _toDisplayString(_ctx.receiverexport.Type), 1),
                      _hoisted_11,
                      _createTextVNode(" Target: " + _toDisplayString(_ctx.receiverexport.Destination), 1),
                      _hoisted_12,
                      _createTextVNode(" Generated: " + _toDisplayString(_ctx.receiverexport.Generated ? _ctx.getHumanDate(_ctx.receiverexport.Generated) : 'n/a'), 1),
                      _hoisted_13,
                      _createTextVNode(" Processed: " + _toDisplayString(_ctx.receiverexport.Processed ? _ctx.getHumanDate(_ctx.receiverexport.Processed) : 'n/a'), 1),
                      _hoisted_14,
                      _createTextVNode(" Acknowledged: " + _toDisplayString(_ctx.receiverexport.Exported ? _ctx.getHumanDate(_ctx.receiverexport.Exported) : 'n/a'), 1),
                      _hoisted_15
                    ])
                  ]),
                  _createVNode("div", _hoisted_16, [
                    (_ctx.receiverexport.Processed && !_ctx.receiverexport.Exported)
                      ? (_openBlock(), _createBlock("button", {
                          key: 0,
                          class: "btn btn-outline-primary",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.acknowledge()))
                        }, "Acknowledge Export Data"))
                      : _createCommentVNode("", true),
                    _hoisted_17
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode("div", _hoisted_21, [
                    (_ctx.receiverexport.Files && _ctx.receiverexport.Files.length && _ctx.receiverexport.Processed)
                      ? (_openBlock(), _createBlock("div", _hoisted_22, [
                          _createVNode("table", _hoisted_23, [
                            _createVNode("thead", null, [
                              _createVNode("tr", null, [
                                _createVNode("th", _hoisted_24, _toDisplayString(_ctx.receiverexport.EmployeeList.length) + " employee" + _toDisplayString((_ctx.receiverexport.EmployeeList.length > 1 ? 's' : '')), 1)
                              ])
                            ]),
                            _createVNode("tbody", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.receiverexport.Files, (file, index) => {
                                return (_openBlock(), _createBlock("tr", { key: index }, [
                                  _createVNode("td", null, [
                                    _createTextVNode(_toDisplayString(file.Name) + " ", 1),
                                    _createVNode("button", {
                                      class: "ms-auto btn btn-sm btn-outline-primary",
                                      onClick: ($event: any) => (_ctx.downloadFile(index))
                                    }, "Download", 8, ["onClick"])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_25, [
      _createVNode("div", _hoisted_26, [
        _createVNode("div", _hoisted_27, [
          _hoisted_28,
          _hoisted_29,
          _createVNode("div", _hoisted_30, [
            _hoisted_31,
            _createVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteExport())),
              "data-bs-dismiss": "modal"
            }, "Delete export")
          ])
        ])
      ])
    ])
  ], 64))
}